module.exports = __webpack_public_path__ + "static/media/iPhone2.ba640645.png";